<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column prop="money" label="金额">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>
      <el-table-column prop="created_time" label="创建日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time) }}
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.state == 0"> 未处理 </span>
          <span v-else> 已完成 </span>
        </template>
      </el-table-column>
      <el-table-column prop="bank_card" label="银行卡">
        <template slot-scope="scope">
          {{ scope.row.bank_card.bank }}
          {{ scope.row.bank_card.card_num }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="描述">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="处理日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time_confirm) }}
        </template>
      </el-table-column>
      <el-table-column prop="bank_card" label="操作">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="7">
              <el-button size="mini" @click="salesService(scope.row)">提现处理</el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>
    <el-dialog title="提现服务" :visible.sync="dialogFormVisible">
      <div class="title1">ID:{{ form.id }}</div>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="操作" prop="state">
          <el-select v-model="form.state" placeholder="请选择操作">
            <el-option label="同意" value="1"></el-option>
            <el-option label="不同意" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="form.describe" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="addSalesService('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        state: "",
        id: "",
        describe: "",
      },
      dialogFormVisible: false,
      multipleSelection: [],
      rules: {
        state: [{ required: true, message: "请输入选择", trigger: "change" }],
      },
    };
  },
  methods: {
    ...mapActions({
      getUserWithdrawalIndexAction: "getUserWithdrawalIndexAction",
      editUserWithdrawalAction: "editUserWithdrawalAction",
    }),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //提现服务
    salesService(row) {
      console.log(row);
      this.dialogFormVisible = true;

      this.form.id = row.id;
    },
    //提现处理
    addSalesService(formName) {
      let order = {
        id: this.form.id,
        describe: this.form.describe,
        state: this.form.state,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editUserWithdrawalAction(order);
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getUserWithdrawalIndexAction({ page: page, status: this.status });
    },
    getPageData() {
      this.getUserWithdrawalIndexAction({
        page: this.page,
      });
    },
  },

  mounted() {
    this.getPageData();
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.withdrawal.result,
  }),
  watch: {
    tableData(newdata) {
      if (newdata.code == 301) {
        this.page = 1;
        this.getPageData();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
